/*
 * Copyright (c) 2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {useAppSelector} from "../../../../../../../redux/hooks";
import {selectConfigSensorWizardState} from "../../../../../../../redux/ducks/AdasPrograms/slice";
import ArgosDialog from "../../../../../../components/Dialogs/ArgosDialog";
import {SensorWizard} from "../SensorWizard";
import React from "react";

export const EditSensorDialog = (props: any) => {
  const wizardState = useAppSelector(selectConfigSensorWizardState)
  const isEditSensorDialogOpen = wizardState !== null

  return (
    <>
      <ArgosDialog
        height='80vh'
        width='60vw'
        open={isEditSensorDialogOpen}
        headerTitle={'Edit Sensor'}
        headerTitleAlign={'left'}
      >
        <SensorWizard onClose={props.closeDialog}/>
      </ArgosDialog>
    </>
  )
}